import { EnvironmentData } from './types';

import development from './environment';
import production from './environment.prod';
import test from './environment.testing';

const environments: EnvironmentData = {
  production,
  development,
  test,
};

export default environments[process.env.NODE_ENV || 'production'];
